<template>
    <div>
        <div
            :id="componentId"
            class="tooltip-wrap"
            :class="[windowSize, positionClasses, additionalClass, { 'show-content-under': blurBackground }]"
            :style="{ width: `${width}px` }"
        >
            <div
                class="tooltip-content fade-up"
                :class="[{ 'tooltip-content_no-close-btn': !showCloseButton }, additionalClass]"
                @click.stop
            >
                <CloseButtonSm v-if="showCloseButton" :additionalClass="'absolute close-right-top'" @close="close" />
                <p v-if="tooltipTitle" class="tooltip-content__title">{{ tooltipTitle }}</p>
                <p
                    v-if="tooltipText"
                    v-html="tooltipText"
                    class="tooltip-content__text font-normal whitespace-normal"
                ></p>

                <VueSimplebar v-if="tooltipList" class="simplebar-tooltip-height">
                    <ul class="tooltip-content__list" :class="[additionalListClass]">
                        <li
                            v-for="(item, index) in tooltipList"
                            :key="index"
                            class="tooltip-content__list-item text-three-dots-nowrap"
                        >
                            {{ listNameToTrack ? item[listNameToTrack] : item }}
                        </li>
                    </ul>
                </VueSimplebar>
                <VueSimplebar v-if="tooltipListHtml" class="simplebar-tooltip-height">
                    <ul class="tooltip-content__list-html" :class="[additionalListClass]">
                        <li
                            class="tooltip-content__list-html_item"
                            v-for="(item, index) in tooltipListHtml"
                            :key="index"
                            v-html="item"
                        ></li>
                    </ul>
                </VueSimplebar>

                <slot :close="close"></slot>
            </div>
        </div>
    </div>
</template>

<script>
import CloseButtonSm from "@components/Buttons/CloseButtonSm.vue"
import { VueSimplebar } from "vue-simplebar"

export default {
    name: "TooltipWithQuestionMarkContent",
    components: { CloseButtonSm, VueSimplebar },
    props: {
        /**
         * @values "small", "regular", "large"
         **/
        windowSize: {
            type: String,
            default: "regular"
        },
        /**
         * @values "top-left", "top-center", "top-right", "center-left", "center-right", "bottom-right", "bottom-center", "bottom-left"
         **/
        positionClasses: {
            type: String,
            default: "bottom-right"
        },
        btnId: {
            type: String,
            required: true
        },
        blurBackground: {
            type: Boolean,
            default: false
        },
        showCloseButton: {
            type: Boolean,
            default: true
        },
        internalContent: {
            type: Boolean,
            default: true
        },
        width: [Number],
        tooltipText: [String],
        tooltipTitle: [String],
        tooltipList: [Array],
        tooltipListHtml: [Array],
        additionalClass: {
            type: String,
            default: null
        },
        additionalListClass: [String],
        listNameToTrack: {
            type: String,
            default: "name"
        },
        componentId: {
            type: String,
            default: "tooltip-wrap"
        }
    },
    methods: {
        close() {
            this.$emit("close")
        },
        setPosition() {
            // Default dimensions
            const gap = 20
            // Body dimensions
            const { scrollWidth, clientHeight } = document.body
            // Tooltip button dimensions
            const openButtonPosition = document.querySelector("#" + this.btnId).getBoundingClientRect()
            let { left, top } = openButtonPosition
            // Tooltip modal dimensions
            const tooltipModal = document.querySelector(`#${this.componentId}`)
            const tooltipModalPosition = tooltipModal.getBoundingClientRect()
            const { width, height } = tooltipModalPosition
            let modalTopDistance = window.scrollY + top + openButtonPosition.height

            // Calculate modal place only inside viewport
            if (left + width > scrollWidth) {
                left = scrollWidth - width - gap * 2
            }
            if (modalTopDistance + height > clientHeight) {
                //modalTopDistance = clientHeight + window.scrollY - height - gap * 2
            }

            // Calculate coordinates
            tooltipModal.style.left = `${left + gap}px`
            tooltipModal.style.top = `${modalTopDistance}px`
            // for resources/js/modules/Expert/views/Marketing/Mailing/MailingReportFilter.vue
            // it is has 'z-index 201'
            tooltipModal.style.zIndex = "999999999"

            // const buttonIcon = document.querySelector("#" + this.btnId)
            // const content = document.querySelector(".tooltip-wrap")
            // const position = buttonIcon.getBoundingClientRect()
            // content.style.top = position.top + "px"
            // content.style.left = position.left + "px"
        }
    },
    mounted() {
        if (!this.internalContent) {
            setTimeout(() => this.setPosition(), 0)
        }
    }
}
</script>
